import { useEffect, useState } from 'react';

// active: when false the counter never starts, even if windowToggle is true.
// This allows callers to restrict counting to specific flow states (e.g. Handover only).
export const useTimer = (initialToggleState: boolean, active = true) => {
  const [windowToggle, setWindowToggle] = useState<boolean>(initialToggleState);
  const [count, setCount] = useState<number>(0);
  let countdownInterval: ReturnType<typeof setTimeout> | undefined;

  // biome-ignore lint/correctness/useExhaustiveDependencies: changing might break feature
  useEffect(() => {
    if (windowToggle && active) {
      countdownInterval = setInterval(() => {
        setCount((prevCount) => prevCount + 1);
      }, 1000);
    } else {
      setCount(0);
      clearInterval(countdownInterval);
    }

    return () => {
      clearInterval(countdownInterval);
    };
  }, [windowToggle, active]);

  return { windowToggle, setWindowToggle, count };
};
